import { render } from "./Insert.vue?vue&type=template&id=0e2b65c6&scoped=true"
import script from "./Insert.vue?vue&type=script&lang=js"
export * from "./Insert.vue?vue&type=script&lang=js"

import "./Insert.vue?vue&type=style&index=0&id=0e2b65c6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2b65c6"]])

export default __exports__